<template>
  <el-dialog title="Cấu hình doanh nghiệp" :visible.sync="visible" width="60%" top="5vh" :close-on-click-modal="false"
    class="config-dialog" :show-close="false">
      <template slot="title">
        <span style="font-weight: 700; font-size: 16px;">Cấu hình doanh nghiệp</span>
      </template>

    <div class="row">
      <!-- Ngành nghề kinh doanh -->
      <div class="col-md-6 mb-3">
        <div class="block-card">
          <div class="block-title">📦 Ngành nghề kinh doanh</div>
          <p style="margin-bottom: 4px;">Lĩnh vực hoạt động chính của doanh nghiệp</p>

          <el-form :model="form">
            <el-form-item label="Ngành nghề chính" required>
              <el-select v-model="form.industry" multiple collapse-tags placeholder="Chọn ngành nghề chính"
                style="width:100%">
                <el-option v-for="item in industryOptions" :key="item.code" :label="item.display"
                  :value="item.code" />
              </el-select>
            </el-form-item>

            <el-form-item label="Lĩnh vực cụ thể">
              <el-input v-model="form.industryDetail" placeholder="Ví dụ: CRM & AI" />
            </el-form-item>

            <el-form-item label="Quy mô doanh nghiệp" required>
              <el-select v-model="form.companySize" placeholder="Chọn quy mô" style="width:100%" clearable>
                <el-option v-for="size in sizeOptions" :key="size" :label="size" :value="size" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- Đối tượng khách hàng -->
      <div class="col-md-6 mb-3">
        <div class="block-card">
          <div class="block-title">👥 Đối tượng khách hàng</div>
          <p style="margin-bottom: 4px;">Phân khúc khách hàng mục tiêu của doanh nghiệp</p>

          <el-form :model="form">
            <el-form-item label="Loại khách hàng" required>
              <el-select v-model="form.customerType" multiple collapse-tags placeholder="Chọn loại khách hàng"
                style="width:100%">
                <el-option v-for="item in customerOptions" :key="item.code" :label="item.display"
                  :value="item.code" />
              </el-select>
            </el-form-item>

            <el-form-item label="Phân khúc chính">
              <el-input v-model="form.segment" placeholder="SME, Startup..." />
            </el-form-item>

            <el-form-item label="Mô tả khách hàng lý tưởng">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 5 }" v-model="form.customerDesc"
                placeholder="Mô tả đặc điểm, nhu cầu, hành vi..." />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">Huỷ</el-button>
      <el-button type="primary" @click="submitBusinessConfig" :disabled="!isFormValid">
        Lưu cấu hình
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  inheritAttrs: false,
  props: ["companySetupAI"],
  data() {
    return {
      visible: true,
      form: {
        industry: [],
        companySize: "",
        customerType: [],
        industryDetail: "",
        segment: "",
        customerDesc: ""
      },

      sizeOptions: [
        "Micro (1-10 nhân viên)",
        "Nhỏ (11-50 nhân viên)",
        "Trung bình (51-200 nhân viên)",
        "Lớn (200+ nhân viên)"
      ],

      industryOptions: [],
      customerOptions: [],
      businessGoalsOptions: [],
    };
  },
  computed: {
    isFormValid() {
      return (
        this.form.industry?.length > 0 &&
        this.form.companySize &&
        this.form.customerType?.length > 0
      );
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    async fetchOptions() {
      const res = await this.$http.post("/api/ai/execute", {
        action: "proxy",
        path: "/ai-business/common-data",
        method: "GET"
      });

      if (res.data) {
        const data = JSON.parse(res.data).data.data;
        this.businessGoalsOptions = data.goal || [];
        this.industryOptions = data.industry || [];
        this.customerOptions = data.customerType || [];
      }
    },
    fetchBusinessInfo() {
      const data = this.companySetupAI;
      if (data) this.mapCompanyData(data);
    },
    mapCompanyData(data) {
      this.form.industry = data.industry.industry.map(i => i.code);
      this.form.industryDetail = data.industry.industryDetails;
      this.form.companySize = data.industry.businessSize;
      this.form.customerType = data.customerSegment.customerTypes.map(i => i.code);
      this.form.segment = data.customerSegment.customerSegment;
      this.form.customerDesc = data.customerSegment.customerDescription;
    },
    async submitBusinessConfig() {
      try {
        const payload = {
          companyCode: this.app.user.companyCode,

          industry: JSON.stringify({
            industry: this.industryOptions.filter(
              i => this.form.industry.includes(i.code)
            ),
            businessSize: this.form.companySize,
            industryDetails: this.form.industryDetail
          }),

          customerSegment: JSON.stringify({
            customerTypes: this.customerOptions.filter(
              c => this.form.customerType.includes(c.code)
            ),
            customerSegment: this.form.segment,
            customerDescription: this.form.customerDesc
          }),

          businessRiskList: JSON.stringify([])
        };

        const resp = await this.$http.post("/api/ai/execute", {
          action: "proxy",
          path: "/ai-business/zalo",
          method: "POST",
          body: payload
        });

        if (resp.data) {
          this.$message.success("Lưu thông tin thành công.");
          this.$emit('config-changed');
        }
      } catch (err) {
        console.error("ERROR:", err);
      }
    }
  },
  mounted() {
    this.fetchOptions();
    this.fetchBusinessInfo();
  }
};
</script>

<style scoped>
.block-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  height: 100%;
}

.block-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.el-dialog {
  word-break: normal;
}

.el-dialog p,
.el-dialog .block-title,
.el-dialog label,
.el-dialog .el-form-item__label {
  word-break: keep-all;
  overflow-wrap: break-word;
  white-space: normal;
}

.el-dialog p {
  line-height: 1.5;
  max-width: 100%;
}

.block-card p {
  color: #64748b;
  font-size: 14px;
}

.el-form-item {
  margin-bottom: 2px;
}

::v-deep .el-textarea__inner {
  word-break: keep-all !important;
  white-space: pre-wrap;
}
</style>